import { useCallback, useState } from "react";
import {
  createShare,
  type ShareLanguage,
  type ShareTranslationRequest,
  type ShareTranslationResponse,
} from "../services/share";

export interface UseShareTranslationReturn {
  createShare: (
    originalText: string,
    translatedText: string,
    fromLang: ShareLanguage,
    toLang: ShareLanguage
  ) => Promise<ShareTranslationResponse["data"] | null>;
  clearShareData: () => void;
  loading: boolean;
  error: string | null;
  shareData: ShareTranslationResponse["data"] | null;
}

export function useShareTranslation(): UseShareTranslationReturn {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [shareData, setShareData] = useState<
    ShareTranslationResponse["data"] | null
  >(null);

  const handleCreateShare = useCallback(
    async (
      originalText: string,
      translatedText: string,
      fromLang: ShareLanguage,
      toLang: ShareLanguage
    ) => {
      setLoading(true);
      setError(null);

      try {
        const request: ShareTranslationRequest = {
          original_text: originalText,
          translated_text: translatedText,
          from_language: fromLang,
          to_language: toLang,
        };

        const result = await createShare(request);

        if (result.success && result.data) {
          setShareData(result.data);
          return result.data;
        } else {
          const errorMessage = result.message || "Share yaratishda xatolik";
          setError(errorMessage);
          return null;
        }
      } catch (err) {
        const errorMessage =
          err instanceof Error ? err.message : "Share yaratishda xatolik";
        setError(errorMessage);
        return null;
      } finally {
        setLoading(false);
      }
    },
    []
  );

  const clearShareData = useCallback(() => {
    setShareData(null);
    setError(null);
  }, []);

  return {
    createShare: handleCreateShare,
    clearShareData,
    loading,
    error,
    shareData,
  };
}
